<template>
  <v-container v-if="linkError">
    <v-card class="pa-5 text-center" flat>
      <v-icon color="error" class="display-2"> mdi-cancel </v-icon>
      <v-card-text class="headline">
        This link has expired. Please have your patient share their records again.
      </v-card-text>
    </v-card>
  </v-container>
  <v-container v-else grid-list-xs>
    <v-row class="pa-6 pb-0">
      <v-col cols="12" sm="12" md="6" lg="4">
        <v-card elevation="2" height="100%" class="stats-card">
          <v-card-title> Patient </v-card-title>
          <v-col cols="12" class="pl-0 pt-0">
            <v-list dense class="pt-0">
              <v-list-item>
                <v-list-item-content>Patient Name:</v-list-item-content>
                <v-chip>
                  {{ patient_data.NAME }}
                </v-chip>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>Patient ID:</v-list-item-content>
                <v-chip>
                  {{ patient_data.PATIENT_ID }}
                </v-chip>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>Gender:</v-list-item-content>
                <v-chip>
                  {{ patient_data.SEX }}
                </v-chip>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>DOB:</v-list-item-content>
                <v-chip>
                  {{ patient_data.BIRTH_DATE }}
                </v-chip>
              </v-list-item>
            </v-list>
          </v-col>
          <v-card-text class="pt-0 pb-0 body-1">{{ patient_data.ADDRESS }}</v-card-text>
          <v-card-text class="pt-0 pb-0 body-1"
            >{{ patient_data.CITY }}, {{ patient_data.STATE }}</v-card-text
          >
        </v-card>
      </v-col>

      <v-col cols="12" sm="12" md="6" lg="4">
        <v-card elevation="2" height="100%" class="stats-card">
          <v-card-title> Membership </v-card-title>
          <v-card-text class="pb-0 condensed body-1"
            >Provider: {{ patient_data.PCP_NAME }}</v-card-text
          >
          <v-card-text class="pb-0 condensed body-1"
            >PCP ID: {{ patient_data.PCP_ID ? patient_data.PCP_ID : 'N/A' }}</v-card-text
          >
          <v-list dense>
            <v-list-item>
              <v-list-item-content>Effective Date</v-list-item-content>
              <v-chip>
                {{ patient_data.ELIGIBLE_MONTH }}
              </v-chip>
            </v-list-item>
          </v-list>
          <v-col cols="12" class="pl-0 pt-0"> </v-col>
        </v-card>
      </v-col>

      <v-col cols="12" sm="12" md="6" lg="4">
        <v-card elevation="2" height="100%" class="stats-card">
          <v-card-title> Risk Metrics </v-card-title>
          <v-list dense class="pt-0">
            <v-list-item>
              <v-list-item-content>Risk Score C</v-list-item-content>
              <v-chip>
                {{ patient_data.RISKSCORE_C ? patient_data.RISKSCORE_C : 'N/A' }}
              </v-chip>
            </v-list-item>
            <v-list-item v-if="insurance !== 'Careplus'">
              <v-list-item-content>Risk Score D</v-list-item-content>
              <v-chip>
                {{ patient_data.RISKSCORE_D ? patient_data.RISKSCORE_D : 'N/A' }}
              </v-chip>
            </v-list-item>
            <!-- <v-list-item>
              <v-list-item-content>Total Expenses</v-list-item-content>
              <v-chip>
                ${{
                  patient_data.TOTAL_EXPENSES ? formatCurrency(patient_data.TOTAL_EXPENSES) : 'N/A'
                }}
              </v-chip>
            </v-list-item>
            <v-list-item>
              <v-list-item-content>Total Revenue</v-list-item-content>
              <v-chip>
                ${{
                  patient_data.TOTAL_REVENUE ? formatCurrency(patient_data.TOTAL_REVENUE) : 'N/A'
                }}
              </v-chip>
            </v-list-item>
            <v-list-item>
              <v-list-item-content>MLR</v-list-item-content>
              <v-chip dark :color="getMLRColor(patient_data.MLR)">
                {{ Math.round(parseFloat(patient_data.MLR) * 100) }}%
              </v-chip>
            </v-list-item> -->
          </v-list>
        </v-card>
      </v-col>
    </v-row>
    <v-row v-if="patientID && insurance" class="pa-6 pt-0">
      <v-col cols="12">
        <PatientConditions :patient="patientID" :insurance="insurance" />
      </v-col>

      <v-col cols="12">
        <HCC :patient="patientID" :insurance="insurance" />
      </v-col>

      <v-col cols="12">
        <institutional :patient="patientID" :insurance="insurance" :recordLimit="5" />
      </v-col>

      <v-col cols="12">
        <professional :patient="patientID" :insurance="insurance" :recordLimit="5" />
      </v-col>

      <v-col cols="12">
        <Rx :patient="patientID" :insurance="insurance" :recordLimit="5" />
      </v-col>

      <v-col cols="12">
        <laboratory :patient="patientID" :insurance="insurance" :recordLimit="5" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from 'axios';
import PatientConditions from '../components/patientinfo/PatientConditions';
import Institutional from '../components/patientinfo/Institutional';
import Professional from '../components/patientinfo/Professional';
import Rx from '../components/patientinfo/Rx';
import Laboratory from '../components/patientinfo/Laboratory';
import HCC from '../components/patientinfo/HCC';

export default {
  data() {
    return {
      dialog: false,
      loading: false,
      tab: null,
      patientID: null,
      insurance: '',
      patient_data: [],
      displayData: true,
      user: '',
      linkError: false,
    };
  },
  components: {
    PatientConditions,
    Institutional,
    Professional,
    Rx,
    Laboratory,
    HCC,
  },
  mounted() {
    this.checkId(this.$route.params.id);
  },
  methods: {
    async checkId(id) {
      await axios
        .get(`/api/sharedpatient/${id}`)
        .then((response) => {
          this.user = response.data[0];
          console.log(this.user);
          this.patientID = this.user.memberId;
          this.insurance = this.user.insurance;
        })
        .catch(() => {
          this.linkError = true;
        });
      this.getPatient();
    },
    async getPatient() {
      this.loading = true;
      // if patientID is passed to modal
      this.patient_data = [];

      const url = `/api/patient/modal/insurance=${this.user.insurance}/${this.user.memberId}`;
      await axios.get(url).then((response) => {
        if (response.data[0]) {
          this.patient_data = response.data[0];
          this.displayData = true;
        } else {
          this.displayData = false;
        }
        this.loading = false;
      });
    },
    formatCurrency(c) {
      if (c != undefined) {
        return parseFloat(c)
          .toFixed(2)
          .replace(/\d(?=(\d{3})+\.)/g, '$&,');
      }
    },

    getMLRColor(MLR) {
      if (MLR > 1) return 'red lighten-1';
      return 'green lighten-1';
    },
  },
  watch: {
    async dialog() {
      // make sure dialog is open before grabbing patientID
      if (this.dialog === true) {
        this.patientID = this.user.PATIENT_ID;
      }
    },
    async patientID() {
      if (this.patientID !== null) {
        this.getPatient();
      }
    },
  },
};
</script>

<style>
.v-dialog--fullscreen {
  overflow-x: hidden !important;
}

.stats-card {
  min-height: 285px;
}
</style>
